import ReactDOM from 'react-dom/client';
import "./index.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import AuthProvider from './Context/ContextProvider';
import { GoogleOAuthProvider } from '@react-oauth/google';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

// ----------------- Add this here -----------------
const suppressedWarnings = [
  'Warning: ', // all React runtime warnings
];

const originalWarn = console.warn;
const originalError = console.error;

const shouldSuppressLog = args => {
  const firstArg = args?.[0];
  const message = typeof firstArg === 'string' ? firstArg : firstArg instanceof Error ? firstArg.message : '';
  return suppressedWarnings.some(w => message.includes(w));
};

console.warn = (...args) => {
  if (!shouldSuppressLog(args)) originalWarn(...args);
};

console.error = (...args) => {
  if (!shouldSuppressLog(args)) originalError(...args);
};
// --------------------------------------------------

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <GoogleOAuthProvider clientId="887542925891-sgokjvl82r1qa9eo6seochi5cum8bhsc.apps.googleusercontent.com">
    <AuthProvider>
      <App />
      <ToastContainer
        position="top-right"
        autoClose={3000}
        className="!tw-top-[50px] !tw-relative custom-toast"
        toastClassName="!tw-top-[50px] !tw-relative custom-toast"
      />
    </AuthProvider>
  </GoogleOAuthProvider>
);

reportWebVitals();
